export default {
  global: {
    send: 'Enviar',
    save: 'Salvar',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    brand: 'HeiGIT - Heidelberg University',
    close: 'Fechar',
    closeAndDoNotShowAgain: 'Fechar e não exibir novamente',
    select: 'Selecionar',
    yes: 'Sim',
    no: 'Não',
    and: 'e',
    noAndDonAskAgain: 'Não (não perguntar novamente)',
    ok: 'OK',
    polygon: 'polígono',
    developedByIntro: 'Serviços desenvolvidos por',
    developedBy: 'HeiGIT gGmbH',
    duration: 'Duração',
    distance: 'Distância',
    elevation: 'Elevação',
    profile: 'Perfil',
    options: 'Opções',
    parameters: 'Parâmetros',
    custom: 'Personalizado',
    customOverlayer: 'Camada adicional personalizada',
    rawRouting: 'Roteamento bruto',
    months: {
      january: 'Janeiro',
      february: 'Fevereiro',
      march: 'Março',
      april: 'Abril',
      may: 'Maio',
      june: 'Junho',
      july: 'Julho',
      august: 'Agosto',
      september: 'Setembro',
      october: 'Outubro',
      november: 'Novembro',
      december: 'Dezembro'
    },
    monthsShort: {
      january: 'Jan',
      february: 'Fev',
      march: 'Mar',
      april: 'Abr',
      may: 'Mai',
      june: 'Jun',
      july: 'Jul',
      august: 'Ago',
      september: 'Set',
      october: 'Otu',
      november: 'Nov',
      december: 'Dez'
    },
    units: {
      km: 'km',
      mi: 'M',
      m: 'm',
      meters: 'metros',
      s: 's',
      seconds: 'segundos',
      minutes: 'minutos',
      hours: 'h',
      days: 'd',
      min: 'min',
      lat: 'lat',
      lng: 'long',
      tones: 'toneladas',
      t: 't',
      kmh: 'km/h'
    },
    layers: {
      macrocounty: 'Macro condado',
      country: 'País',
      region: 'Região',
      county: 'Condado',
      macroregion: 'Macro região',
      neighbourhood: 'Bairro',
      locality: 'Localidade',
      borough: 'Município',
      localadmin: 'Administração local',
      address: 'Endereço',
      street: 'Rua',
      venue: 'Local',
      rawCoordinate: 'Coordenadas simples lng,lat',
      notAvailable: 'Não disponível',
      postalcode: 'Código postal',
      'undefined': 'Não definido',
      ocean: 'Oceano'
    },
    population: 'População',
    green: 'Verde',
    noise: 'Ruído',
    steepness: 'Inclinação',
    surface: 'Superfície',
    roadaccessrestrictions: 'Road access restrictions',
    waytype: 'tipo de caminho',
    suitability: 'Adequação',
    waycategory: 'Categoria do caminho',
    tollways: 'Pedágios',
    traildifficulty: 'Dificuldade da trilha',
    osmid: 'OSM ID',
    countryinfo: 'Informação do país'
  }
}
